import { useState } from 'react';
import { api } from '../../data/api';
import toast from 'react-hot-toast';
import { capitalLetter } from '../../helpers/general.helper';
import CustomModal from '../modal/CustomModal';
import { ButtonVariants, SmartButton } from '../buttons/GralButton';
 
type DeleteButtonProps = {
  itemId: string;
  itemName: string;
  onDelete: () => void;
  apiEndpoint: string;
  entityName: string;
};
 
const DeleteButton = ({ 
  itemId, 
  itemName, 
  apiEndpoint,
  entityName = '<desconocido>',
  onDelete 
}: DeleteButtonProps) => {
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
 
  const handleConfirmDelete = async () => {
	setIsDeleting(true);
	try {
	  await api.delete(`${apiEndpoint}/${itemId}`);
	  toast.success(`${capitalLetter(entityName)} eliminado`);
	  onDelete();
	  setShowModal(false);
	} catch (err) {
	  console.error("### error", err);
	  toast.error(`Error eliminando el ${entityName}`);
	} finally {
	  setIsDeleting(false);
	}
  };
 
  return (
	<>
	  <button 
		onClick={() => setShowModal(true)}
		className="action-button"
	  >
		🗑️
	  </button>
		<CustomModal
		  showModal={showModal}
		  setShowModal={setShowModal}
		  titulo='Confirmar Eliminación'
		  width='auto'
		  height='auto'
		>
		  <h2>Confirmar eliminación</h2>
		  <p>{`¿Estás seguro de querer eliminar "${itemName}"? Esta acción no se puede deshacer.`}</p>
		  <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
			  <SmartButton 
				  onClick={() => setShowModal(false)}
				  variant={ButtonVariants.CANCEL}
				  >
				  Cancelar
			  </SmartButton>
			  <SmartButton 
				  onClick={handleConfirmDelete}
				  variant={ButtonVariants.DELETE}
				  >
				  {isDeleting ? 'Eliminando...' : 'Eliminar'}
			  </SmartButton>
		  </div>
		</CustomModal>
	</>
  );
};
 
export default DeleteButton;